import { SellerMemberFragment } from '@gql'
import { useStoreState } from '@store/hooks'

export default function useCurrentSellerMembers():
  | SellerMemberFragment[]
  | undefined {
  return useStoreState((state) => state.seller.members)
}
